import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BLOG_POSTS } from "../data/blogPosts";

import { useTranslation } from 'react-i18next';
export default function BlogHero() {
  const { t } = useTranslation();
  const featuredPost = BLOG_POSTS[0];

  return (
    <section className="relative overflow-hidden border-b border-zinc-900 bg-black">
      <div className="absolute inset-0 grid-bg opacity-40" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#09090B]" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 pt-12 pb-10 sm:pt-20 sm:pb-16">
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500 mb-6">
          // CONTENT MARKETING ENGINE
        </div>
        <h1 className="font-display text-3xl sm:text-5xl md:text-6xl lg:text-7xl uppercase leading-[0.9]">
          AI Agent<br />
          <span className="text-amber-500">{t('blog_hero.insights')}</span>
        </h1>
        <p className="mt-6 max-w-2xl text-base sm:text-lg text-zinc-400 leading-relaxed">
          Practical guides, honest comparisons, real case studies, and data-driven insights
          on AI digital workers — everything you need to deploy autonomous agents in your business.
        </p>

        {/* Featured post teaser */}
        {featuredPost && (
          <div className="mt-10 flex items-center gap-4 flex-wrap">
            <Link
              to={`/blog/${featuredPost.slug}`}
              className="inline-flex items-center justify-center w-full sm:w-auto gap-2 bg-amber-500 hover:bg-amber-400 text-black px-6 py-3 font-bold uppercase tracking-wider text-xs transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500"
            >
              <span className="w-2 h-2 bg-black rounded-full animate-pulse" />
              Latest: {featuredPost.title} <ArrowRight className="w-4 h-4" />
            </Link>
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-400">
              {BLOG_POSTS.length} articles · Updated weekly
            </span>
          </div>
        )}
      </div>
    </section>
  );
}
